module.exports = __webpack_public_path__ + "static/media/rating-star-empty.b471afcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/rating-star-empty.svg
// module id = 888
// module chunks = 0